import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import NewsletterForm from '../../../components/forms/NewsletterForm';
import { useNewsletterApi } from '../../../hooks/useNewsletterApi';
import { useNavigate } from 'react-router-dom';
import { NewsletterDTO } from '../../../services/apiClient';

const NewsletterCreate: React.FC = () => {
  const { create, isLoading } = useNewsletterApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Newsletters', href: '/admin/newsletters' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: NewsletterDTO) => {
    try {
      setIsSubmitting(true);
      await create(data);
      navigate('/admin/newsletters');
    } catch (error) {
      console.error('Error creating Newsletter:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/newsletters"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Content.Newsletter.Edit"
    >
      <NewsletterForm
        initialValues={{} as NewsletterDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/newsletters')}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default NewsletterCreate;
